// composables/useCollaborationApi.ts
import { useApi } from '~/composables/useApi';
import { useApi_multipart } from '~/composables/useApi_multipart';

export const useCollaborationApi = () => {
  const fetchInitUserList = () => {
    return useApi('/api/common/userAllList_json.do?isIncludeDept=N', {
      method: 'POST',
    });
  };

  const fetchInitUserDeptList = () => {
    return useApi('/api/common/userAllList_json.do?isIncludeDept=Y', {
      method: 'POST',
    });
  };

  const fetchDefaultBoardSearchDt = () => {
    return useApi('/api/hcm/avt/avtMng/selectDefaultBoardSearchDt.do', {
      method: 'POST',
    });
  };

  const fetchBoardList = () => {
    return useApi('/api/hcm/avt/avtMng/selectBoardList.do', {
      method: 'POST',
    });
  };

  const fetchData = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/selectData.do', {
      method: 'GET',
      query: params,
    });
  };

  const fetchPlan = (params: any, options?: { skipLoading?: boolean }) => {
    return useApi('/api/hcm/avt/avtMng/selectPlan.do', {
      method: 'POST',
      query: params,
      skipLoading: options?.skipLoading === true,
    });
  };

  const fetchActivityList = (params: URLSearchParams, options?: { skipLoading?: boolean }) => {
    return useApi('/api/hcm/avt/avtMng/activityList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
      skipLoading: options?.skipLoading === true,
    });
  };

  /** 업무 활동 로그 조회 (JSP avtLogList.do) */
  const fetchAvtLogList = (params: { findYear: string; planId: string }) => {
    return useApi('/api/hcm/common/log/avtLogList.do', {
      method: 'GET',
      query: params,
    });
  };

  const fetchHomeActivityList = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/newHomeActivityList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const saveBoard = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/insertBoard.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const deleteBoard = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/deleteBoard.do', {
      method: 'POST',
      query: params,
    });
  };

  const insertCategory = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/insertCategory.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const deleteCategory = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/deleteCategory.do', {
      method: 'POST',
      query: params,
    });
  };

  const fetchCoopUsersPresetImport = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/selectPlanCoopUserPreset.do', {
      method: 'POST',
      query: params,
    });
  };

  const insertPlan = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/insertPlan.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const updatePlan = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/updatePlan.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const deletePlan = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/deletePlan.do', {
      method: 'POST',
      query: params,
    });
  };

  const saveActivity = (formData: FormData) => {
    return useApi_multipart('/api/hcm/avt/avtMng/saveActivity.do', {
      method: 'POST',
      body: formData,
      headers: {
        'Html-Tag-Escape': 'N',
      },
    });
  };

  const deleteActivity = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/deleteActivity.do', {
      method: 'POST',
      query: params,
    });
  };

  const moveCategory = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/moveCategory.do', {
      method: 'POST',
      query: params,
    });
  };

  const fetchCategoryList = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/categoryList.do', {
      method: 'POST',
      query: params,
    });
  };

  /** 전체 보드-카테고리 목록 (업무 모달 카테고리 선택 등) */
  const fetchAllBoardCategoryList = () => {
    return useApi('/api/hcm/avt/avtMng/selectData.do', {
      method: 'GET',
    });
  };

  const movePlan = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/movePlan.do', {
      method: 'POST',
      query: params,
    });
  };

  const fetchMergePlanList = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/mergePlanList.do', {
      method: 'POST',
      query: params,
    });
  };

  const mergePlan = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/mergePlan.do', {
      method: 'POST',
      query: params,
    });
  };

  const updateImportYn = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/updateImportYn.do', {
      method: 'GET',
      query: params,
    });
  };

  const updateNotificationYn = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/updateNotification.do', {
      method: 'GET',
      query: params,
    });
  };

  const fetchSettingData = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/selectSettingData.do', {
      method: 'POST',
      query: params,
    });
  };

  const updateSettingData = (params: any) => {
    const body = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => body.append(k, String(v)));
    return useApi('/api/hcm/avt/avtMng/saveSettingData.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: body.toString(),
    });
  };

  const fetchCoopPlanCnt = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/selectCoopPlanCnt.do', {
      method: 'POST',
      query: params,
    });
  };

  const fetchCoopPlanList = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/selectCoopPlanList.do', {
      method: 'GET',
      query: params,
    });
  };

  const fetchMovePlanList = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/selectMovePlanList.do', {
      method: 'GET',
      query: params,
    });
  };

  const deleteCoopPlan = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/deleteCoopPlan.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const updateCoopPlanPersonal = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/updateCoopPlanPersonal.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  const updateCoopPlanAll = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/updateCoopPlanAll.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const updateMovePlanAll = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/updateMovePlanAll.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const fetchPlanList = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/selectPlanList.do', {
      method: 'POST',
      query: params,
    });
  };

  const fetchHomeBoardList = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/selectHomeBoardList.do', {
      method: 'GET',
      query: params,
    });
  };

  const takeOverPlan = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/takeOverPlan.do', {
      method: 'POST',
      query: params,
    });
  };

  const insertAvtActivityRead = (params: any) => {
    return useApi('/api/hcm/avt/avtMng/insertAvtActivityRead.do', {
      method: 'POST',
      query: params,
    });
  };

  const updateBoardSort = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/updateBoardSort.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const fetchCategoryPlanList = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/selectCategoryPlanList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const takeOverCategory = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/takeoverCategory.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const saveCoopCategory = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/saveCoopCategory.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const fetchHomeData = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/selectHomeData.do', {
      method: 'GET',
      query: params,
    });
  };

  const updateCategoryName = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/updateCategoryName.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const updateSortOrder = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/updateSortOrder.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded', // 꼭 명시
      },
      body: params.toString(),
    });
  };

  const fetchHomeDefaultData = () => {
    return useApi('/api/hcm/avt/avtMng/selectHomeDefaultData.do', {
      method: 'POST',
    }).catch(error => {
      console.error('[fetchHomeDefaultData] API 호출 실패:', error);
      // 에러 발생 시 기본값 반환
      return {
        selectedHomeBoardId: '',
        findHomeActivityStartDt: '',
        findHomeActivityEndDt: '',
        homeActivityDtKeepYn: 'Y',
      };
    });
  };

  /** 홈 활동 검색 기본값 저장 (유지하기·시작/종료일) */
  const saveHomeDefaultData = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/saveHomeDefaultDataInfo.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 카테고리 템플릿 — 업무 구분(활동 구분) 목록 (JSP: selectAvtGbnList.do) */
  const fetchSelectAvtGbnList = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/selectAvtGbnList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 카테고리 템플릿 — 보드/카테고리 템플릿 목록 (JSP: selectCategoryTmplDataList.do) */
  const fetchSelectCategoryTmplDataList = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/selectCategoryTmplDataList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 카테고리 템플릿 저장 (JSP: savePopCategoryTmpl.do, FormData) */
  const fetchSavePopCategoryTmpl = (formData: FormData) => {
    return useApi('/api/hcm/avt/avtMng/savePopCategoryTmpl.do', {
      method: 'POST',
      body: formData,
      headers: {},
    });
  };

  /** 업무활동 템플릿 - 활동유형 목록 (JSP: selectAvtCategoryList.do) */
  const fetchSelectAvtCategoryList = () => {
    return useApi('/api/hcm/avt/avtMng/selectAvtCategoryList.do', {
      method: 'POST',
    });
  };

  /** 업무활동 템플릿 - 템플릿 목록 (JSP: selectActivityTmplList.do) */
  const fetchSelectActivityTmplList = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/selectActivityTmplList.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 업무활동 템플릿 - 즐겨찾기 토글 (JSP: updateImportAvt.do) */
  const fetchUpdateImportAvt = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/updateImportAvt.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 보드 실행기간 DB 초기화 — selectData.do 내부 updateBoardTerm 호출 */
  const fetchClearBoardSearchTerm = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/selectData.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  /** 홈 선택한 보드 저장 () */
  const fetchSaveHomeBoard = (params: URLSearchParams) => {
    return useApi('/api/hcm/avt/avtMng/saveHomeBoard.do', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });
  };

  return {
    fetchInitUserList,
    fetchInitUserDeptList,
    fetchDefaultBoardSearchDt,
    fetchClearBoardSearchTerm,
    fetchBoardList,
    fetchData,
    fetchPlan,
    fetchActivityList,
    fetchAvtLogList,
    fetchHomeActivityList,
    saveBoard,
    deleteBoard,
    insertCategory,
    deleteCategory,
    fetchCoopUsersPresetImport,
    insertPlan,
    updatePlan,
    deletePlan,
    saveActivity,
    deleteActivity,
    moveCategory,
    fetchCategoryList,
    fetchAllBoardCategoryList,
    movePlan,
    fetchMergePlanList,
    mergePlan,
    updateImportYn,
    updateNotificationYn,
    fetchSettingData,
    updateSettingData,
    fetchCoopPlanCnt,
    fetchCoopPlanList,
    fetchMovePlanList,
    deleteCoopPlan,
    updateCoopPlanPersonal,
    updateMovePlanAll,
    updateCoopPlanAll,
    fetchPlanList,
    fetchHomeBoardList,
    takeOverPlan,
    fetchCategoryPlanList,
    takeOverCategory,
    saveCoopCategory,
    fetchHomeData,
    updateCategoryName,
    updateSortOrder,
    insertAvtActivityRead,
    updateBoardSort,
    fetchHomeDefaultData,
    saveHomeDefaultData,
    fetchSelectAvtGbnList,
    fetchSelectCategoryTmplDataList,
    fetchSavePopCategoryTmpl,
    fetchSelectAvtCategoryList,
    fetchSelectActivityTmplList,
    fetchUpdateImportAvt,
    fetchSaveHomeBoard
  };
};
